import {createApp} from "vue";
import app from "./app.vue";
import router from "./router";
import store from "./store";

// 加载进度条
import nprogress from "nprogress";
import "nprogress/nprogress.css";
// 进度条配置
nprogress.configure({
  // 初始进度
  minimum: 0.2,
  // 动画
  easing: "linear",
  // 动画时长
  speed: 500,
  // 不显示进度环
  showSpinner: false
});

// 引入 vant
import vant from 'vant';
import 'vant/lib/index.css';

// 引入 axios
import axios from "axios";

const nApp = createApp(app);

nApp.provide("axios", axios);

nApp.use(store);
nApp.use(router);
nApp.use(vant);
nApp.mount("#app");
